<h1>{{locale.selectCompareDate}}</h1>

<div class="dialog" #dialog>
  <form class="form" [formGroup]="form">
    <iv-live-date-time-selector
      class="form__control form__date-time-picker"
      [formControlName]="filterTypes.DATE_TIME"
      [locale]="locale"
      [clearButton]="{date: true, time: false}"
      [container]="isFullScreenOpened ? dialog : undefined"
    ></iv-live-date-time-selector>

    <ng-container *ngIf="mainSeriesSelectedFilters">
      <ng-container *ngFor="let key in form.controls">
        <iv-live-dropdown-new
          *ngIf="key !== filterTypes.DATE_TIME && key !== filterTypes.REALTIME && key !== filterTypes.STOCK_ID"
          class="form__control form__dropdown-selector"
          [class.form__control-disabled]="form.disabled"
          [formControlName]="key"
          [label]="getFilterName(key)"
          [listValues]="$any(filterPattern[key])"
          [templateField]="{list: 'description', input: key !== filterTypes.MONEYNESS && key !== filterTypes.IVX_TERM ? 'name' : 'description'}"
          [contentWidth]="true"
        ></iv-live-dropdown-new>
      </ng-container>
    </ng-container>
  </form>

  <div class="button-container">
    <button
      class="iv-flat-button"
      (click)="submit()"
      statistic
      [statisticElementName]="'Compare date dialog apply'"
      [disabled]="form.invalid"
    >
      {{locale.apply}}
    </button>
  </div>
</div>
